import React, { useContext, useEffect, useState } from 'react';
import _get from 'lodash/get';

import { AppContext, ModalContext, CustomFooter } from 'commons-ui';
import useService from './useService';
import { ITournamentDetails } from '../types';

interface IOpponentsDetailsListProps {
	tournamentDetails: ITournamentDetails;
}
const BUTTON_LABELS = {
	AGREE: 'Confirm',
	DISAGREE: 'Back'
};

const useOpponentsDetails = ({ tournamentDetails }: IOpponentsDetailsListProps) => {
	const [timelineIsCollapsed, setOpponentsListIsCollapsed] = useState<boolean>(true);
	const { setModalConfig } = useContext(ModalContext);
	const [timelineData, setOpponentsGameDetails] = useState<any>();
	const [dataFetchComplete, setDataFetchComplete] = useState<boolean>(false);
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const { showAlert } = useContext(AppContext);
	const { getOpponentsGameDetails } = useService();
	const onAgreeHandler = async () => {
		setModalConfig({ isOpen: false });
		setOpponentsListIsCollapsed(false);
	};
	const onDisAgreeHandler = () => {
		setModalConfig({ isOpen: false });
	};

	const setOpponentsListIsCollapsedHandler = (flag: boolean) => {
		if (flag || dataFetchComplete) {
			setOpponentsListIsCollapsed(flag);
		} else {
			setModalConfig({
				isOpen: true,
				header: 'Data Fetch Confirmation',
				content: 'This is a high cost operation, Do you want to continue ?',
				footer: (
					<CustomFooter
						agreeLabel={BUTTON_LABELS.AGREE}
						disagreeLabel={BUTTON_LABELS.DISAGREE}
						onAgreeClick={onAgreeHandler}
						onDisagreeClick={onDisAgreeHandler}
					/>
				)
			});
		}
	};

	const handleDatalistFetchData = () => {
		return timelineData;
	};

	useEffect(() => {
		const fetchRowData = async () => {
			try {
				setShowLoader(true);
				const fetchedData = await getOpponentsGameDetails(tournamentDetails);
				setOpponentsGameDetails({ rowCount: fetchedData.rowCount, data: fetchedData.data });
			} catch (error: any) {
				showAlert(_get(error, 'error', 'Error while fetching data'), { type: 'error' });
			} finally {
				setShowLoader(false);
				setDataFetchComplete(true);
			}
		};

		if (!timelineIsCollapsed && !dataFetchComplete) {
			fetchRowData();
		}
	}, [timelineIsCollapsed, dataFetchComplete]);

	return {
		timelineIsCollapsed,
		setOpponentsListIsCollapsedHandler,
		dataFetchComplete,
		showLoader,
		handleDatalistFetchData
	};
};

export default useOpponentsDetails;
